import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/description-exit.ogg'
import _imports_1 from '@/assets/audio/description-exit.mp3'
import _imports_2 from '@/assets/audio/description-enter.ogg'
import _imports_3 from '@/assets/audio/description-enter.mp3'
import _imports_4 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-1898f78e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "audioDescriptionOverlayExit",
  preload: "auto"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/ogg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mp3"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", {
  preload: "auto",
  autoplay: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_2,
    type: "audio/ogg"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_3,
    type: "audio/mp3"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header-text flex" }, "Item to Exchange", -1))
const _hoisted_7 = { class: "detailed-box flex-column" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "quantity-adjuster-box flex-column"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Qty.", -1))
const _hoisted_11 = { style: {"font-size":"1.75rem"} }
const _hoisted_12 = { class: "quantity-adjuster-interactive flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1", -1))
const _hoisted_14 = ["max"]
const _hoisted_15 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_16 = { class: "cancel-confirm-box flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_description_overlay = _resolveComponent("item-description-overlay")!
  const _component_item_obtain_overlay = _resolveComponent("item-obtain-overlay")!
  const _component_gem_counter = _resolveComponent("gem-counter")!
  const _component_cancel_confirm_button = _resolveComponent("cancel-confirm-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", _hoisted_1, _hoisted_4, 512),
    _hoisted_5,
    (_ctx.activeItemId)
      ? (_openBlock(), _createBlock(_component_item_description_overlay, {
          key: 0,
          item: _ctx.activeItem,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeItemId = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.purchasedItemId)
      ? (_openBlock(), _createBlock(_component_item_obtain_overlay, {
          key: 1,
          "obtained-items": _ctx.purchasedItem,
          onExit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = false))
        }, null, 8, ["obtained-items"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "item-purchase-overlay-bg",
      class: _normalizeClass({ bg: true, 'zoom-fade-in': _ctx.active, 'zoom-fade-out': !_ctx.active }),
      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.exitOutsideCheck && _ctx.exitOutsideCheck(...args))),
      onAnimationend: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'main-box': true, 'zoom-in': _ctx.active, 'zoom-out': !_ctx.active })
      }, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "item-description-box flex",
            style: _normalizeStyle(_ctx.cssBox),
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.activeItemId = _ctx.item.id), ["self"]))
          }, [
            _createElementVNode("img", {
              class: "item-img",
              src: require(`@/assets/images/${_ctx.item.id}.webp`),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.activeItemId = _ctx.item.id), ["self"]))
            }, null, 8, _hoisted_8),
            _createElementVNode("div", {
              class: "item-description-text flex-column text",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.activeItemId = _ctx.item.id), ["self"]))
            }, [
              _createElementVNode("div", {
                class: "flex item-header-text text",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.activeItemId = _ctx.item.id), ["self"]))
              }, [
                _createElementVNode("p", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeItemId = _ctx.item.id))
                }, _toDisplayString(_ctx.item.name), 1),
                _createVNode(_component_gem_counter, {
                  text: _ctx.shopItem.cost[0].quantity,
                  icon: `${_ctx.shopItem.cost[0].id}.webp`,
                  small: true,
                  red: _ctx.insufficientFunds,
                  onImageClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeItemId = _ctx.shopItem.cost[0].id))
                }, null, 8, ["text", "icon", "red"])
              ]),
              _createElementVNode("div", {
                class: "flex star-box",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeItemId = _ctx.item.id))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.rarity, (i) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: i,
                    class: "star-img",
                    src: _imports_4
                  }))
                }), 128))
              ]),
              _createElementVNode("p", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeItemId = _ctx.item.id))
              }, _toDisplayString(_ctx.item.description), 1)
            ])
          ], 4),
          (!_ctx.insufficientFunds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.quantityToPurchase), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['plus-minus', { disabled: _ctx.quantityToPurchase === 1 }]),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setQuantityToPurchase(_ctx.quantityToPurchase - 1)))
                  }, " - ", 2),
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.quantityToPurchase) = $event)),
                    type: "range",
                    min: "1",
                    max: _ctx.numPurchasable,
                    style: _normalizeStyle({
                '--quantity': `${(_ctx.quantityToPurchase / _ctx.numPurchasable) * 100}%`,
              })
                  }, null, 12, _hoisted_14), [
                    [
                      _vModelText,
                      _ctx.quantityToPurchase,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.numPurchasable), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass([
                'plus-minus',
                { disabled: _ctx.quantityToPurchase === _ctx.numPurchasable },
              ]),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setQuantityToPurchase(_ctx.quantityToPurchase + 1)))
                  }, " + ", 2)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.insufficientFunds)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Insufficient Funds"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_cancel_confirm_button, {
            text: "Cancel",
            onPressed: _cache[13] || (_cache[13] = ($event: any) => (_ctx.active = false))
          }),
          _createVNode(_component_cancel_confirm_button, {
            text: "Exchange",
            disabled: _ctx.insufficientFunds,
            onPressed: _ctx.purchase
          }, null, 8, ["disabled", "onPressed"])
        ])
      ], 2)
    ], 34)
  ], 64))
}